import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "crm:flex crm:items-center crm:flex-col crm:lg:flex-row crm:lg:w-[80%]" }
const _hoisted_2 = { class: "crm:flex crm:items-center" }

import {computed, onMounted, ref} from "vue";
import {useComponent} from "fallco-frontend-framework/src/vue/composable/useComponent";
import {useDesignSystem} from "../composable/useDesignSystem";
import {delete_cross, alert_warning} from '../svg/svgs.js'

const COOKIE_NAME = 'mostraComunicazione';


export default {
  __name: 'TheEmergencyBanner',
  props: {
  /**
   * Data di partenza del banner
   */
  startDate: {
    type: String,
    default: '2023-11-12'
  },
  /**
   * Data di fine del banner
   */
  endDate: {
    type: String,
    default: '2023-12-02T11:00'
  }
},
  setup(__props) {

/**
 * @doc
 * Gestisce la visualizzazione del banner di avviso manutenzione.
 * Setta un cookie con id delle date di inizio/fine.
 * In modo che quando se ne creerà un altro va a resettare la preferenza di visualizzazione
 * dell'utente poichè non si ha più un match con l'id precedente.
 */
const props = __props

const {design_colors} = useDesignSystem();
const {is_mobile_view} = useComponent();

const cookieID = computed(() => `${props.startDate}_${props.endDate}`)

/**
 * Recupera il cookie dal nome
 * @param cookieName
 * @return {*}
 */
function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [key,value] = el.split('=');
    cookie[key.trim()] = value;
  })
  return cookie[cookieName];
}

const isShowComunicazione = computed(() => {
  return (Date.now() >= Date.parse(props.startDate)) && (Date.now() < Date.parse(props.endDate));
});

const isShowBanner = ref(isShowComunicazione.value)

/**
 * Controlla se è presente il cookie
 * @param cookieName
 * @return {boolean}
 */
const haveCookie = (cookieName) => {
  return getCookie(cookieName) !== undefined
}

/**
 * Nasconde il messaggio di emergenza e setta il cookie con la preferenza
 */
function nascondiMessaggio() {
  document.cookie = `mostraComunicazione=${cookieID.value}; expires=Sund, 19 Feb 2056 07:00:00 UTC`
  isShowBanner.value = false;
}

onMounted(() => {
  let cookieRetrieved = getCookie(COOKIE_NAME);
  if(!isShowComunicazione.value || (cookieRetrieved && cookieRetrieved !== cookieID.value)) document.cookie = `mostraComunicazione=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  if(haveCookie(COOKIE_NAME)) isShowBanner.value = false;
})

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (isShowComunicazione.value && isShowBanner.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["crm:fixed crm:w-full crm:lg:min-h-[80px] crm:py-4 crm:lg:py-0 crm:bg-[#FDEEDC] crm:shadow-lg crm:border-t crm:border-warning crm:bottom-0 crm:flex-col crm:lg:flex-row crm:flex crm:items-center crm:justify-between crm:text-warning-200 crm:px-4", {'crm:z-50': !_unref(is_mobile_view), 'crm:z-40': _unref(is_mobile_view)}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_icon, {
            icon: _unref(alert_warning),
            class: "crm:hidden 2crm:xl:flex crm:mr-2 crm:my-2 crm:lg:my-0",
            stroke: _unref(design_colors).warning['200']
          }, null, 8 /* PROPS */, ["icon", "stroke"]),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "crm:mb-0" }, [
            _createTextVNode("I servizi del "),
            _createElementVNode("strong", null, "CRM Notarile"),
            _createTextVNode(" non saranno raggiungibili "),
            _createElementVNode("strong", null, "dalle ore 08.00 alle ore 12:00 di sabato 2 dicembre 2023"),
            _createTextVNode(" per interventi di manutenzione straordinaria. Ci scusiamo per il disagio.")
          ], -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "crm:p-2 crm:text-primary! crm:rounded-md crm:underline crm:cursor-pointer",
            onClick: _withModifiers(nascondiMessaggio, ["prevent"])
          }, "Non visualizzare più questo messaggio"),
          _createVNode(_component_base_icon, {
            icon: _unref(delete_cross),
            class: "crm:ml-4 crm:cursor-pointer",
            stroke: _unref(design_colors).warning['200'],
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => (isShowBanner.value = false), ["prevent"]))
          }, null, 8 /* PROPS */, ["icon", "stroke"])
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

}